export const SUPERVISOR_HOME_PAGE = () => "/supervisor-home";

export const SUPERVISOR_EVALUATION_PAGE = (evaluationId: string) =>
  `/supervisor-evaluation/${encodeURIComponent(evaluationId)}`;

export const SUPERVISOR_EVALUATION_PICK_FORM_PAGE = (registrationId: string) =>
  `/supervisor-evaluation/registration/${encodeURIComponent(registrationId)}`;

export const SUPERVISOR_STORE_EVALUATION_START_PAGE = () =>
  "/supervisor-store-evaluation";

export const SUPERVISOR_STORE_EVALUATION_PAGE = (evaluationId: string) =>
  `/supervisor-store-evaluation/${encodeURIComponent(evaluationId)}`;
